import React from 'react';
import { features, images } from '../data/mock';
import {
  UserPlus,
  CreditCard,
  Users,
  Briefcase,
  CalendarCheck,
  Bus,
  BookOpen,
  Headphones,
  Package,
  ClipboardList,
  FileCheck,
  Smartphone
} from 'lucide-react';

const iconMap = {
  UserPlus: UserPlus,
  CreditCard: CreditCard,
  Users: Users,
  Briefcase: Briefcase,
  CalendarCheck: CalendarCheck,
  Bus: Bus,
  BookOpen: BookOpen,
  Headphones: Headphones,
  Package: Package,
  ClipboardList: ClipboardList,
  FileCheck: FileCheck,
  Smartphone: Smartphone
};

const FeaturesSection = () => {
  return (
    <section id="features" className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block text-teal-600 font-semibold text-sm tracking-wider uppercase mb-4">
            Comprehensive Modules
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-800 mb-6">
            Everything You Need to Manage Your School
          </h2>
          <p className="text-lg text-slate-600">
            From student enrollment to daily operations, EdKonect provides all the tools your institution needs to thrive in the digital age.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {features.map((feature, index) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <div
                key={feature.id}
                className="group bg-white rounded-2xl p-6 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-slate-100"
              >
                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-teal-500 to-cyan-500 flex items-center justify-center mb-5 group-hover:scale-110 transition-transform duration-300">
                  {IconComponent && (
                    <IconComponent className="w-6 h-6 text-white" />
                  )}
                </div>
                <h3 className="text-lg font-semibold text-slate-800 mb-3">
                  {feature.title}
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Feature Image */}
        <div className="mt-20 relative">
          <div className="bg-gradient-to-r from-teal-500 to-cyan-500 rounded-3xl p-1">
            <div className="bg-white rounded-3xl overflow-hidden">
              <img
                src={images.technology}
                alt="EdKonect Dashboard"
                className="w-full h-80 object-cover"
              />
            </div>
          </div>
          {/* Floating Badge */}
          <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 bg-white rounded-full shadow-xl px-8 py-4 border border-slate-100">
            <p className="text-slate-800 font-semibold text-center">
              <span className="text-teal-600">Modern Interface</span> • Easy to Learn • Quick to Deploy
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
